import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Select, Store } from '@ngxs/store';
import { ChannelState } from '@x/ecommerce-shop/app/channel/state';
import { AuthLogout } from '@x/ecommerce-shop/app/core/auth/state/auth.actions';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { MenuState, MenuStateModel } from '@x/ecommerce-shop/app/core/menu/state/menu.state';
import { RegionOpenOverlay } from '@x/ecommerce-shop/app/core/region/state/region.actions';
import {
  IRegionStateModel,
  RegionState,
} from '@x/ecommerce-shop/app/core/region/state/region.state';
import { IShopAuthUser, IShopChannelDetail } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'x-channel-router',
  templateUrl: './channel-router.component.html',
  styleUrls: ['./channel-router.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-channel-router' },
})
export class ChannelRouterComponent {
  drawerOpened: boolean = false;

  @Select(AuthState.loggedInUser) user$: Observable<IShopAuthUser>;
  @Select(RegionState) regionState$: Observable<IRegionStateModel>;
  @Select(MenuState) menuState$: Observable<MenuStateModel>;
  @Select(ChannelState.activeChannel) activeChannel$: Observable<IShopChannelDetail | null>;

  showRegion$: Observable<boolean> = this.store.select(ChannelState.activeChannel).pipe(
    map((channel) => {
      if (!channel) return false;
      return channel?.regions?.length > 1;
    }),
  );

  @ViewChild('drawer') drawer: MatSidenav;

  constructor(private store: Store) {}

  toggleDrawer() {
    this.drawer.toggle();
  }

  openRegionOverlay() {
    this.store.dispatch(new RegionOpenOverlay());
    this.toggleDrawer();
  }

  logout() {
    this.store.dispatch(new AuthLogout());
  }

  onSideNavScroll($event: Event) {
    $event.stopPropagation();
  }
}
